import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaymentIntent, StripeCardElementOptions, StripeCardNumberElementOptions, StripeElementsOptions } from '@stripe/stripe-js';
import { StripeCardComponent, StripeCardNumberComponent, StripeService } from 'ngx-stripe';
import { PaymentService } from '../../services/payment/payment.service';
import { AppService } from 'src/app/services/app/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { PackageService } from 'src/app/services/package/package.service';
import { CommonService } from 'src/app/services/common/common.service';
//stripe API Type
// for new and most popular = typ:1
// for offer = typ:2
// for package (admin pacakges) = typ:3
// for company package = typ:4
//for individual buying affiliate package = typ :6
//company buy package created by admin (course) =typ : 8
//company buy offers created by admin = typ :9
//company buys custom packages = typ:10
@Component({
  selector: 'app-stripe-payment',
  templateUrl: './stripe-payment.component.html',
  styleUrls: ['./stripe-payment.component.scss']
})
export class StripePaymentComponent {
  // @ViewChild(StripeCardComponent) card!: StripeCardComponent;
  @ViewChild(StripeCardNumberComponent) card!: StripeCardNumberComponent;
  // cardOptions: StripeCardElementOptions = {
  //   style: {
  //     base: {
  //       iconColor: '#666EE8',
  //       color: 'red',
  //       fontFamily: "regularSans",
  //       fontSize: '17px',
  //       '::placeholder': {
  //         color: '#CFD7E0',

  //       },
  //     },
  //   },
  // };
  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#000000',
        fontFamily: 'regularSans',
        fontSize: '15px',
        '::placeholder': {
          color: "#9ea9ba",
          fontFamily: 'regularSans',
        },
      },
    },
  };
  cardOptionsNumber: StripeCardNumberElementOptions = {
    ...this.cardOptions,
    showIcon: true,
    classes: {
      base: "test"
    }
  };
  elementsOptions: StripeElementsOptions = {
    locale: 'en',
    // clientSecret :'sk_test_51JXXFeG5VqJP3zTPrpTRUHMMmo7XGQQtBNUnkTm5nQAauLvz1rpLFxaUe8DBVWn8z05SlCZEUTayVbQaOa12toZ700vsudBhm6'

  };
  stripeCard!: FormGroup;
  paymentElementForm!: FormGroup;
  public paymentType: string = "stripe";
  private customerId!: string;
  public tokenCardId!: string;
  public tokenId!: string;
  public error!: any;
  public voucherCode: string = '';
  public courseId;
  public paymentIntentId!: string;
  public courseTransactionId!: string;
  public itemId!: string;
  public isValidVoucher: boolean = false;
  public isExpiredVoucher: boolean = false;
  public voucherForm!: FormGroup;
  public paymentData: any;
  public courseData: any;
  public itemType!: any;
  public isVoucherError: boolean = false;
  public isOfferPackage: boolean = false;
  public offerData: any;
  isFlipped: boolean = false;
  public isAddUser: boolean = false;
  public isYearly!: boolean;
  public perUser;
  public errorMsg!: string;
  public isCustomPackage: boolean = false;
  public isBuyFreeOfferPackage: boolean = false
  refferalCode: any;
  constructor(public dialogRef: MatDialogRef<StripePaymentComponent>, private appService: AppService, @Inject(MAT_DIALOG_DATA) public dialogData: any, private cd: ChangeDetectorRef,
    private fb: FormBuilder, private stripeService: StripeService, private router: Router, private paymentService: PaymentService, private spinner: NgxSpinnerService,
    private packageService: PackageService, private commonService: CommonService
  ) { }



  flipCard() {
    this.isFlipped = !this.isFlipped;
  }

  ngOnInit(): void {

    // Get the raw JSON string from localStorage
    const storedData = localStorage.getItem('training-portal.referralCodeData');

    if (storedData !== null) {
      const parsedData = JSON.parse(storedData);
      this.refferalCode = parsedData.referralCode;
    }

    this.voucherForm = this.fb.group({
      voucherCode: ['', Validators.required]
    })
    this.stripeCard = this.fb.group({
      name: ['', [Validators.required]],
      amount: ['', [Validators.required]],
    });
    this.getCustomerId()
    if (this.dialogData.hasOwnProperty('offer_package')) {

      // impement this when company is buying the offer package from admin (i.e Basic,Advanced,Expert)
      this.itemId = this.dialogData.id;
      this.itemType = this.dialogData.type
      this.isBuyFreeOfferPackage = this.dialogData.isBuyFree
      if (this.dialogData.pl == 'y') {
        this.isYearly = true;
      }
      else {
        this.isYearly = false;
      }
      this.offerData = this.dialogData
      if (this.dialogData.hasOwnProperty('custom_package')) {
        this.isCustomPackage = true
      }
      else {
        this.isOfferPackage = true
      }
    }
    if (this.dialogData.id && !this.dialogData.hasOwnProperty('offer_package')) {
      // implement this when user(individual) is buying course or company is buying the packaged course from admin
      this.isOfferPackage = false
      this.itemId = this.dialogData.id;
      this.courseData = this.dialogData
      this.paymentData = {
        vat: this.calculateVatPer(this.dialogData.pr, this.dialogData.vat_percentage),
        vat_percentage: this.dialogData.vat_percentage,
        discount_price: 0,
        discount_percentage: 0,
        price: Number(this.calculatePrice(this.dialogData.pr, this.dialogData.vat_percentage))
      }
      this.itemType = this.dialogData.type
    }
  }
  calculateVatPer(price, vat_per) {
    let vat
    if (price > 0 && vat_per > 0) {
      vat = (price * vat_per) / 100
    } else {
      vat = 0
    }
    return vat.toFixed(2)
  }
  calculatePrice(price, vat_percentage) {
    let aPrice: number;
    if (price >= 0 && vat_percentage >= 0) {
      aPrice = price + ((price * vat_percentage) / 100)
    }
    else {
      aPrice = price
    }

    return aPrice.toFixed(2)
  }
  onPaymentType(value: string) {
    this.paymentType = value
  }
  getCustomerId() {
    this.spinner.show()
    this.paymentService.createCustomerId().subscribe((success: any) => {
      if (success.status == 200) {
        this.customerId = success.st_cus_id;
        this.spinner.hide()
      }
    })
  }
  createToken(): void {
    if (this.isValidVoucher && (this.voucherForm.get('voucherCode')?.value == '')) {
      this.isVoucherError = true;
      return
    }
    else {
      this.isVoucherError = false;
      this.spinner.show()
      this.error = ""
      const name = this.stripeCard.get('name')?.value;
      this.stripeService
        .createToken(this.card.element, { name })
        .subscribe((result: any) => {
          if (result.token) {
            this.tokenCardId = result.token.card.id
            this.tokenId = result.token.id
            this.createCard()
            // Use the token
          } else if (result.error) {
            // Error creating the token
            this.spinner.hide()
            this.error = result.error.message
          }
        });
    }

  }
  createCard() {
    this.paymentService.createCard(this.customerId, this.tokenId).subscribe((response) => {
      if (response) {
        this.getPaymentIntentId()
      }
    }, (error) => {
      this.spinner.hide()
      this.error = error
    })
  }
  getPaymentIntentId() {
    // this.spinner.show()

    // here i want to set refferal code if no this.voucherCode


    let data: any = {
      "item_id": this.itemId,
      "st_card_id": this.tokenCardId,
      "voucher_code": this.isValidVoucher ? this.voucherForm.get('voucherCode')?.value : '',
      "typ": this.itemType,
      referral_code: this.voucherForm.get('voucherCode')?.value ? '' : this.refferalCode
    }
    if (this.isCustomPackage || this.isOfferPackage) {
      data["pl"] = this.offerData["pl"]
      data["e_u"] = this.offerData["a_u"]
    }
    if (this.courseData && this.courseData.hasOwnProperty('t')) {
      data["c_type"] = this.courseData.t
    }
    this.paymentService.buyItem(data).subscribe((success: any) => {
      if (success.status == 200) {
        this.paymentIntentId = success.p_intent_id;
        this.courseTransactionId = success.course_transactions_id;
      }
      this.retrievePaymentIntent();
    }, (error) => {
      this.error = error;
      this.spinner.hide()
    });
  }
  retrievePaymentIntent() {
    this.paymentService.stripePaymentIntent(this.paymentIntentId).subscribe((res: any) => {
      this.confirmCardPayment()
    }, (error) => {
      this.spinner.hide()
      this.error = error;
    })
  }
  confirmCardPayment() {
    this.paymentService.stripeConfirmPayment(this.paymentIntentId).subscribe(res => {
      this.indexOrderPlace()
    }, (error) => {
      this.spinner.hide()
      this.error = error;
    })
  }
  indexOrderPlace() {
    let data: any = {
      "item_id": this.itemId,
      "payment_intent_id": this.paymentIntentId,
      "course_transactions_id": this.courseTransactionId,
      "typ": this.itemType,
      "voucher_code": this.isValidVoucher ? this.voucherForm.get('voucherCode')?.value : '',
      referral_code: this.voucherForm.get('voucherCode')?.value ? '' : this.refferalCode
    }
    if (this.courseData && this.courseData.hasOwnProperty('t')) {
      data["c_type"] = this.courseData.t
    }
    if (this.isCustomPackage || this.isOfferPackage) {
      data["pl"] = this.offerData["pl"]
      data["e_u"] = this.offerData["a_u"]
    }
    // this.spinner.show()
    this.paymentService.itemIndexOrderPlace(data).subscribe((success: any) => {

      localStorage.removeItem('training-portal.referralCodeData');

      this.spinner.hide()
      this.appService.showToastMessage('success', success.msg)
      this.dialogRef.close()
      let userData = JSON.parse(this.appService.getData('training-portal.userInfo'))
      userData["t_off"] = 1
      this.appService.storeData('training-portal.userInfo', JSON.stringify(userData))
      if (this.isOfferPackage || this.isCustomPackage) {
        let ofData = success.data
        ofData["type"] = "offer_package"
        this.router.navigate(['order-purchased'], { queryParams: { data: JSON.stringify(ofData) } });
      }
      else {
        if (this.dialogData.hasOwnProperty('userType')) {
          this.router.navigate(['order-purchased'], { queryParams: { data: JSON.stringify(success.data) } });
        }
        else {
          this.router.navigate(['order-purchased'], { queryParams: { data: JSON.stringify(success.data) } });
        }
      }
    }, (error) => {
      this.spinner.hide()
      this.error = error.msg;
    });
  }
  applyVoucher() {
    if (this.voucherForm.valid) {
      this.spinner.show();
      let data: any = {
        voucher_code: this.voucherForm.get('voucherCode')?.value,
        c_i: this.itemId
      };
      this.paymentService.voucherValidation(data).subscribe((success: any) => {
        this.spinner.hide();
        if (success.status == 200) {
          this.paymentData = success;
          this.paymentData["price"] = this.paymentData["course_price"]
          this.isValidVoucher = success.is_valid;
          this.isVoucherError = false;
          if (success.is_valid == 1) {
            this.isValidVoucher = true;
          }
          else {
            this.isValidVoucher = false
          }
          if (success.is_expire == 1) {
            this.isExpiredVoucher = true;
          }
          else {
            this.isExpiredVoucher = false
          }
          this.isExpiredVoucher = success.is_expire;
          this.cd.markForCheck();
        }
      });
    }
  }
  onPayPal() {
    this.spinner.show();
    let referralCodeData: any;
    let data = {
      "item_id": this.itemId,
      voucher_code: this.isValidVoucher ? this.voucherForm.get('voucherCode')?.value : '',
      referral_code: this.voucherForm.get('voucherCode')?.value ? '' : this.refferalCode,
      "typ": this.itemType
    }
    if (this.isCustomPackage || this.isOfferPackage) {
      data["pl"] = this.offerData["pl"]
      data["e_u"] = this.offerData["a_u"]
    }
    this.paymentService.payPalPurchase(data).subscribe((success: any) => {
      this.spinner.hide();
      if (success.status == 200 && (success.data.is_purchased == 0)) {
        var newWindow = window.open(success.data.url, '_blank', 'height=700,width=700');

        this.dialogRef.close()
      } else if (success.status == 200 && (success.data.is_purchased == 1)) {
        this.appService.showToastMessage('success', success.msg)
        this.dialogRef.close()
        this.router.navigate(['order-purchased'])
      }

    });
  }
  onBuyFreeOffer() {
    let data: any = {
      "item_id": this.itemId,
      "typ": this.itemType,
      "pl": this.offerData["pl"],
      "e_u": this.offerData["a_u"]
    }
    this.paymentService.buyFreeOffer(data).subscribe((success: any) => {
      this.spinner.hide()
      this.appService.showToastMessage('success', success.msg)
      let userData = JSON.parse(this.appService.getData('training-portal.userInfo'))
      userData["t_off"] = 1
      this.appService.storeData('training-portal.userInfo', JSON.stringify(userData))
      this.commonService.updateSidebarData("offer_purchased")
      this.dialogRef.close()
      let ofData = success.data
      ofData["type"] = "offer_package"
      this.router.navigate(['order-purchased'], { queryParams: { data: JSON.stringify(ofData) } });

    }, (error) => {
      this.spinner.hide()
      this.error = error.msg;
    });
  }
  onClickFreeCourse() {
    this.spinner.show();
    let data: any = {
      c_i: this.itemId,
      voucher_code: this.isValidVoucher ? this.voucherForm.get('voucherCode')?.value : '',
      "typ": this.itemType
    };
    this.paymentService.BuyJob(data).subscribe((success) => {
      this.spinner.hide();
      if (success.status == 200) {

        this.appService.showToastMessage('success', success.msg)
        this.dialogRef.close()
        this.router.navigate(['order-purchased'], { queryParams: { data: JSON.stringify(success.data) } });
      }
    });
  }
  onAddUser() {
    this.isAddUser = !this.isAddUser
  }
  addSeat() {
    if (this.perUser && this.perUser > 0) {
      this.errorMsg = ""
      let obj = {
        "fea": this.itemId,
        "e_u": this.perUser,
        "pl": this.offerData.pl,
        "fe_t": ""
      }
      if (this.isOfferPackage) {
        obj["fe_t"] = 'o'
      }
      else {
        obj["fe_t"] = 'c'
      }
      this.spinner.show()
      this.packageService.getFeatureCalc(obj).subscribe({
        next: (success: any) => {
          this.spinner.hide()
          if (success.status == 200) {
            for (let key in success.msg) {
              if (this.offerData.hasOwnProperty(key)) {
                this.offerData[key] = success.msg[key];
              }
            }
          }
        },
        error: (error: any) => {

          this.commonService.handleError(error)
        }
      })
    }
    else {
      this.errorMsg = "Please enter valid number"
    }
  }
}
